// develop constants
export const AUTH_USER_TOKEN_KEY = 'LanderAmplify.TokenKey';
export const API_ENDPOINT = 'http://localhost:3001/';
export const API_URL = 'https://lxxjnv2ud1.execute-api.us-east-1.amazonaws.com/dev';

export const API_VIDEO_UPLOAD = 'http://13.59.21.152:3006/upload';
export const API_VIDEO_STATUS = 'http://13.59.21.152:3006/status';

export const API_IMAGE_UPLOAD = `${API_URL}/images`;

export const API_PROJECT = `${API_URL}/projects`;
export const API_PAGES = `${API_URL}/pages`;

export const API_EVENTS = `${API_URL}/events`;
export const API_PAYMENT = 'http://localhost:3002/paymentUp';
export const API_STRIPE = `${API_URL}/stripe`;
export const API_ZAPIER = `${API_URL}/zapier`;
export const API_AI_PAGE_GENERATOR = 'https://main-532jor4d2q-uc.a.run.app';

export const DESIGN_WIDTH = 1024;

export const COLORS = {
  anchorGuideStroke: '#fa55e9',
  anchorGuideFill: '#ffaaf6',
  anchorGuideAlt: '#fa55e9',
  anchorGuideText: '#2c2c2c',
};

export const FONTS = {
  anchorLabel: '11px Arial',
};

export const S3_PAGES = 'editor.data.live';
export const CONSULT_URL = 'https://app.dev.autofunnel.ai';
export const STRIPE_API = `${API_URL}/stripe`;
export const API_SECTIONS = `${API_URL}/sections`;
export const TEMPLATES_URL = 'https://mech-templates.s3.amazonaws.com';
export const API_STATISTIC = `${API_URL}/statistic`;
export const AMPLIFY_CLIENT_ID = "25mo5sl4ophb4hi6bbqn9rgn2p";
export const AMPLIFY_POOL_ID = "us-east-1_14cjA4Cug";
export const ENVIRONMENT = 'DEV'
export const STRIPE_KEY = 'pk_test_51HsMXSFwzXnXny40nfgNFXJfDaUZ0NbLclCWPWp76OzAXVuhsvVUHblJpOGeEuVaIRYJpLZFp2P5uNy6xkXACUQQ006RMbXnIs';
export const GOOGLE_TAG = 'GTM-WMRQR3T'
export const UPLOAD_API = 'https://image-upload.autofunnel.ai';
//export const UPLOAD_API = 'http://localhost:3001';
export const USE_MOCKED_DATA = true;

export const StripeProducts = {
  'Basic':{
    'monthly':{
      '1000':{id:'price_1Mvr2SIw2eOqESjKaT9wDnWk', price:'693'},
      '750':{id:'price_1Mvr1wIw2eOqESjKM1Z5XX9u', price:'520'},
      '500':{id:'price_1Mvr1oIw2eOqESjKQtFNo8FY', price:'346'}, 
      '250':{id:'price_1Mvr1fIw2eOqESjKGArOBN3x', price:'173'}, 
      '100':{id:'price_1Mvr1WIw2eOqESjKQPoVjlib', price:'99'}
    },
    'annually':{
      '1000':{id:'price_1Mvr1DIw2eOqESjKDshD6V16', price:'6648'}, 
      '750':{id:'price_1Mvr0KIw2eOqESjKIfH0oe5O', price:'4992'}, 
      '500':{id:'price_1MvqzwIw2eOqESjKeTjPGhE4', price:'3324'}, 
      '250':{id:'price_1MvqzdIw2eOqESjKIppe8WHP', price:'1668'}, 
      '100':{id:'price_1MvpuOIw2eOqESjKBbZgI8Hf', price:'948'}
    }
  },
  'Plus':{
    'monthly':{
      '250':{id:'price_1Mvr8dIw2eOqESjKf5vCejfG', price:'199'}, 
      '750':{id:'price_1Mvr8lIw2eOqESjKFNfCBHm6', price:'332'}, 
      '1250':{id:'price_1Mvr8sIw2eOqESjKIPMzEBsS', price:'497'}, 
      '1750':{id:'price_1Mvr90Iw2eOqESjKh5MTJ1aZ', price:'695'}, 
      '2500':{id:'price_1Mvr9nIw2eOqESjKLVKovI1Q', price:'995'}
    },
    'annually':{
      '250':{id:'price_1Mvr5AIw2eOqESjKjMFeUNz6', price:'1908'}, 
      '750':{id:'price_1Mvr5WIw2eOqESjKD03KyvC6', price:'3180'}, 
      '1250':{id:'price_1Mvr5hIw2eOqESjKaaXHFDy3', price:'4764'}, 
      '1750':{id:'price_1Mvr5sIw2eOqESjKcYoFhLP8', price:'6672'}, 
      '2500':{id:'price_1Mvr8BIw2eOqESjKp5adN4ht', price:'9552'}
    }
  },
  'Pro':{
    'monthly':{
      '500':{id:'price_1MvrCIIw2eOqESjKiOCOqyFx', price:'299'}, 
      '1250':{id:'price_1MvrCOIw2eOqESjKXtHCeQI7', price:'374'}, 
      '2500':{id:'price_1MvrCVIw2eOqESjKFl8iyzuw', price:'747'}, 
      '3750':{id:'price_1MvrCcIw2eOqESjKYIvGadtc', price:'1121'}, 
      '5000':{id:'price_1MvrCjIw2eOqESjKdCdTGCz0', price:'1495'}
    },
    'annually':{
      '500':{id:'price_1MvrB1Iw2eOqESjKi25C1aOZ', price:'2868'},
      '1250':{id:'price_1MvrBJIw2eOqESjKo13xrbrU', price:'3588'}, 
      '2500':{id:'price_1MvrBUIw2eOqESjKOW3iD5DT', price:'7164'}, 
      '3750':{id:'price_1MvrBlIw2eOqESjK0bJhMfxt', price:'10764'}, 
      '5000':{id:'price_1MvrBwIw2eOqESjKNf789EgS', price:'14340'}
    }
  }
}

export const API_AI_REROLL_TEXT = 'https://main2-ikaevrdlna-uc.a.run.app';